<template>
  <div class="design-details">
    <a href="#" class="edit-details" @click.prevent="$emit('editDetail')">
      <i class="ti ti-edit"></i>
    </a>
    <div class="position-relative form-group details w-100">
      <h2>{{ data.name }}</h2>
      <span v-html="this.$util.timestampToDateTime(parseInt(data.date_created))" class="col-6 date-created"></span>
      <div :class="`col-6 pr-0 design-status flag text-right ${data.status}`">
        <span class="m-0">{{ listStatus[data.status] != undefined ? listStatus[data.status].label : '' }}</span>
      </div>
    </div>

    <Status :config="{ storeId, designId, data, extraAttributes, loaded: config.loaded }"></Status>

    <div class="description w-100">
      <div v-if="$_.isArray(data.designs) && data.designs.length > 0" class="form-group">
        <label class="col-12 mb-0 p-0">Blueprint:</label>
        <ul class="list-blueprint">
          <li v-for="(url, index) in data.designs" :key="index" :class="`ext ext-${this.$util.getExtensionFromString(url)}`">
            <a :href="url" @click.prevent="handeClickBlueprint(url)">{{ this.$util.getExtensionFromString(url) ?? 'Link' }}</a>
          </li>
        </ul>
      </div>
      <div v-if="hasArtworks" class="form-group mt-2">
        <label class="col-12 mb-0 p-0">Artwork:</label>
        <ul class="list-blueprint">
          <li v-if="artworks.front" :class="`ext ext-${this.$util.getExtensionFromString(artworks.front)}`">
            <a :href="artworks.front" @click.prevent="handeClickBlueprint(artworks.front)">Front</a>
          </li>
          <li v-if="artworks.back" :class="`ext ext-${this.$util.getExtensionFromString(artworks.back)}`">
            <a :href="artworks.back" @click.prevent="handeClickBlueprint(artworks.back)">Back</a>
          </li>
          <li v-if="artworks.cut" :class="`ext ext-${this.$util.getExtensionFromString(artworks.cut)}`">
            <a :href="artworks.cut" @click.prevent="handeClickBlueprint(artworks.cut)">Cut</a>
          </li>
        </ul>
      </div>
      <div class="form-group">
        <label class="col-12 mb-0 p-0">Shop Name: </label>
        <span class="select-all">{{ data.account_name }}</span>
      </div>
      <div class="form-group">
        <label class="col-12 mb-0 p-0">Seller: </label>
        <span class="select-all">{{ data.user_name }}</span>
      </div>
    </div>

    <div class="attribute w-100">
      <div v-if="data.designer_name" class="form-group">
        <label class="col-12 mb-0 p-0">Designer: </label>
        <span class="select-all">{{ data.designer_name }}</span>
      </div>
      <template v-if="$_.isObjectLike(data.attributes)">
        <div v-for="(attribute, index) in data.attributes" :key="index" :class="`form-group ${index}`">
          <label class="col-12 mb-0 p-0 text-capitalize">{{ data.more.attributes[index] ? data.more.attributes[index].label : index }}: </label>
          <span class="select-all">{{ Object.values(attribute).join(', ') }}</span>
        </div>
      </template>
      <div v-if="data.quantity" class="form-group">
        <label class="col-12 mb-0 p-0">Quantity: </label>
        <span class="select-all" :class="{ 'text-danger font-weight-bold': data.quantity > 1 }">{{ data.quantity || '-' }}</span>
      </div>
      <div v-if="$_.isArray(data.note) && data.note.length > 0" class="form-group">
        <label class="col-12 mb-0 p-0">Note</label>
        <ul class="notes">
          <template v-for="(note, index) in data.note" :key="index">
            <li v-if="String(note).length > 0" v-html="$util.autoLink(note)"></li>
          </template>
        </ul>
      </div>
    </div>
    <hr />
  </div>
</template>

<script>
import Status from './Status.vue'
import Event from '@/helper/event.js'
export default {
  emits: ['change-preview', 'editDetail'],
  mixins: [Event],
  components: {
    Status
  },
  computed: {
    storeId() {
      return this.config?.storeId
    },
    designId() {
      return this.config?.designId
    },
    data() {
      return this.config?.data
    },
    more() {
      return this.data.more || {}
    },
    listStatus() {
      return this.more.status || {}
    },
    extraAttributes() {
      return this.config?.extraAttributes || {}
    },
    artworks() {
      const art = this.data?.artworks || {}
      return {
        front: art.front || art.artwork_front || this.data?.artwork_front,
        back: art.back || art.artwork_back || this.data?.artwork_back,
        cut: art.cut || art.artwork_cut || this.data?.artwork_cut
      }
    },
    hasArtworks() {
      return this.artworks.front || this.artworks.back || this.artworks.cut
    }
  },
  methods: {
    handeClickBlueprint(url) {
      if (!Object.keys(this.$util.options.extension.image).includes(this.$util.getExtensionFromString(url))) {
        const link = document.createElement('a')
        link.href = this.$util.addQueryParam(url, { download: 1 })
        link.click()
      } else if (this.more?.settings?.open_blueprint == 'modal') {
        this.$emitter.emit('SubModal', {
          name: 'full-screen-image-preview',
          data: {
            files: [url],
            config: {
              thumbnail: true,
              background: true
            }
          }
        })
      } else if (this.more?.settings?.open_blueprint == 'next_to') {
        this.$emit('change-preview', url)
      } else {
        window.open('/preview?attached=' + encodeURIComponent(url), '_blank')
      }
    }
  },
  props: {
    config: Object
  }
}
</script>
